var ADDON_ID="storybook/source-loader",PANEL_ID=`${ADDON_ID}/panel`;

export { ADDON_ID, PANEL_ID };
